/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as l from "react";
import { GridContext as o } from "../../utils/GridContext.mjs";
import { TableSelection as s } from "@progress/kendo-react-data-tools";
const b = (t) => {
  var a;
  const e = l.useContext(o), r = { ...t.tableStyle };
  return (a = e.vsRef.current) != null && a.tableTransform && (r.transform = e.vsRef.current.tableTransform), /* @__PURE__ */ l.createElement(
    s,
    {
      selectable: t.selectable,
      onRelease: e.selectionRelease,
      childRef: (n) => {
        e.tableElementRef.current = n;
      }
    },
    /* @__PURE__ */ l.createElement(
      "table",
      {
        className: t.tableClassName,
        role: "presentation",
        style: r,
        ref: e.tableElementRef
      },
      t.children
    )
  );
};
export {
  b as GridTableScrollable
};
